import '@rb/shared/codecs/schemas-loader';
import { CATEGORY_SCHEMAS } from '@rb/shared/codecs/registry';
import { decode } from '@rb/shared/codecs/generic-codec';

// Collections that build-json emits as a single top-level tuple (not an
// array of tuples). Their R2 file already IS the tuple itself.
const SINGLETON_COLLECTIONS = new Set([
  'gameConfig',
  'serverAttendanceRewards',
  'serverEventAttendanceRewards',
  'serverPwaAttendanceRewards',
]);

/**
 * Decode an R2 server collection JSON into a human-readable object/array.
 *
 * - indexed/composite collections: array of positional tuples → array of objects.
 * - singleton collections (gameConfig, serverAttendanceRewards): a single tuple → object.
 *
 * Returns null when no schema is registered (e.g. client* collections, which
 * already ship as readable JSON).
 */
export function tryDecodeCollection(collectionName: string, parsed: unknown): unknown | null {
  const schema = CATEGORY_SCHEMAS[collectionName];
  if (!schema) return null;
  if (!Array.isArray(parsed)) return null;
  if (SINGLETON_COLLECTIONS.has(collectionName)) {
    return decode(schema, parsed as unknown[]);
  }
  return parsed.map((tuple) => decode(schema, tuple as unknown[]));
}

export function hasDecoder(collectionName: string): boolean {
  return collectionName in CATEGORY_SCHEMAS;
}
